import React from "react";
import {Redirect} from "react-router";
import withStyles from "@material-ui/core/styles/withStyles";
import UpdatePatientTS from "components/Forms/PatientForm/AddExistingForm.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import api from "../../api/Api";
import Loader from "../../components/Loader";


export default class updatePatient extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            patientId: null
        }
    }

    componentDidMount() {
        this.CallReadApi(this.props.match.params.patientID);
        this.setState({patientId: this.props.match.params.patientID})
    }


    CallReadApi = (patientID) => {
        var postBody = {

            // "clinic_master_id": clinicMasterID,
            "_id": patientID
        };
        api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
            this.setState({data: json.data.data[0]})
        });
    };


    render() {
        if (this.state.data)
            return (
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className="">Update Patient</h4>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} md={12} sm={12}>
                                            <UpdatePatientTS history={this.props.history}
                                                             generateNotification={this.props.generateNotification}
                                                             patient={this.state.data} patientID={this.state.patientId}
                                                             clinicMasterId={this.props.match.params.clinicMasterID}/>
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>);
        else  return (<Loader/>)
    }
}


// WEBPACK FOOTER //
// ./src/views/Patients/updatePatientTS.jsx